import { ChakraProvider , defaultSystem  } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ChakraProvider value={defaultSystem}>
    <App />
  </ChakraProvider>
);

